// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1_l-i","title":"AfterBackImages_title__1SMit","images":"AfterBackImages_images__1iDlV"};